import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCell = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 67 63",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeOpacity: .62,
		strokeWidth: 6.25,
		d: "M50.882 39.983c-8.443 15.601-22.54 20.663-29.169 18.729-6.628-1.934-13.173-9.177-10.328-16.519s16.525-7.342 18.476-15.321c1.951-7.98 6.312-25.806 16.641-23.223s12.823 20.734 4.38 36.334Z"
	})
});
export default SvgIconCell;
